import { styled } from '@mui/material'
import TextInput from '../../../../../../../../components/editors/input/TextInput'
import { colorPalette } from '../../../../../../../../style/colorPalette'

export const ConfigContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '16px',
})

export const SectionContent = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  overflowY: 'auto',
})

export const FormSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '16px',
})

export const FormLabel = styled('label')({
  fontSize: '14px',
  fontWeight: 500,
  color: colorPalette.monotone[10],
  marginBottom: '4px',
})

export const EmptyConfigContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: colorPalette.monotone[1],
})

export const EmptyConfigText = styled('span')({
  fontSize: '14px',
  color: colorPalette.monotone[4],
  textAlign: 'center',
})

export const PageTitleInput = styled(TextInput)({
  width: '50%',
  maxWidth: '400px',
  marginTop: '8px',
})
